<template>
  <div class="chats">
    <div
      v-for="(msgData, index) in chatLog"
      :key="`${msgData.senderId}-${index}`"
      class="chat"
      :class="{ 'chat-left': msgData.senderId === contact.id }"
    >
      <div class="chat-avatar">
        <b-avatar
          size="36"
          :src="msgData.senderId === contact.id ? contact.avatar : profileUserAvatar"
        />
      </div>
      <div class="chat-body">
        <div class="chat-content">
          <p>{{ msgData.message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
  },
  props: {
    chatData: {
      type: Object,
      required: true,
    },
    profileUserAvatar: {
      type: String,
      required: true,
    },
  },
  computed: {
    contact() {
      return this.chatData.contact || {}
    },
    chatLog() {
      return this.chatData.chat?.chat || []
    },
  },
}
</script>
